﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconUserCode } from "@tabler/icons-react";

export const TiposUsuarioIcon = IconUserCode;
export const TiposUsuarioHelpText = '* Aquí puede ver los diferentes tipos de usuarios.';

export class catTiposUsuario extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "UserTypes";
        this.def.columns.c_category_id.defaultValue = "UserTypes";
        this.Title = "Tipos de Usuario";
        this.HelpText = TiposUsuarioHelpText;
        this.Icon = TiposUsuarioIcon;
    }
}